(function () {
    'use strict';

    angular
        .module('app.detailInfluencerGroup')
        .factory('detailInfluencerGroupService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope)
            {
                var service = {};

                function handleRequest(url, method, params)
                {
                    var deferred = $q.defer();
                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params)
                    }

                    $http(req).success(function (response) {
                        deferred.resolve(response);
                    })
                    .error(function () {
                        deferred.reject(null);
                    });

                    return deferred.promise;
                }

                function getInfluencerGroupInfo(influencer_group_id) {
                    var url_getInfluencerGroupInfo = $rootScope.apiUrl + 'influencerGroup/getInfluencerGroupInfo/' + influencer_group_id;
                    return handleRequest(url_getInfluencerGroupInfo, 'GET', null);
                }

                function getManualAddedInfluencerList(params)
                {
                    var url_getManualAddedInfluencerList = $rootScope.apiUrl + 'influencerGroup/getManualAddedInfluencerList/' + params;
                    return handleRequest(url_getManualAddedInfluencerList, 'GET', null);
                }

                function getInfluencerGroupInfluencerKPI (params)
                {
                    var url_getInfluencerGroupInfluencerKPI = $rootScope.apiUrl + "influencerGroup/getInfluencerGroupInfluencerKPI";
                    return handleRequest(url_getInfluencerGroupInfluencerKPI, "POST", params);
                }

                function deleteInfluencerManualAdded (params)
                {
                    var url_deleteInfluencerManualAdded = $rootScope.apiUrl + "influencerGroup/deleteInfluencerManualAdded";
                    return handleRequest(url_deleteInfluencerManualAdded, "POST", params);
                }

                function getInfluencerDemoGraphicData(influencerId) {
                    var url = $rootScope.apiUrl + 'getInstagramAudienceData/' + influencerId;
                    return handleRequest(url, 'GET', null);
                }

                service.getInfluencerGroupInfo = getInfluencerGroupInfo;
                service.getManualAddedInfluencerList = getManualAddedInfluencerList;
                service.getInfluencerGroupInfluencerKPI = getInfluencerGroupInfluencerKPI;
                service.deleteInfluencerManualAdded = deleteInfluencerManualAdded;
                service.getInfluencerDemoGraphicData = getInfluencerDemoGraphicData;
                return service;
            }
        ])
})();
